import { MethodologySubData } from '../../methodology/methodology';
import { SessionMessage } from '../../session-message/session-message';

export function getEvaluateMethodologyPrompt(
  sessionMessageList: SessionMessage[],
  methodology?: { title?: string; description?: string; subData?: MethodologySubData }
) {
  if (!methodology) {
    return '';
  }

  let chatHistory = '';

  sessionMessageList.forEach((message) => {
    chatHistory += `Sales Rep: ${message.subData.salesMessage} \n Customer: ${message.subData.customerMessage} \n`;
  });

  return `Analyze the conversation history between "Customer" and "Sales Rep" provided below. Assess the seller's performance using the specified methodology and accompanying rubric. Provide a detailed evaluation including:

1. A reason for the overall score
2. Overall improvements for the sales approach
3. Individual evaluations for each criterion in the rubric, including:
   - The criterion being evaluated
   - A rating (1-5) for each criterion
   - A reason for each rating
   - Specific improvements for each criterion

<CONVERSATION_HISTORY>
${chatHistory}
</CONVERSATION_HISTORY>

<METHODOLOGY>
${methodology.title}

${methodology.description}
</METHODOLOGY>

<METHODOLOGY-RUBRIC>
${methodology?.subData?.rubrics.join('\n')}
</METHODOLOGY-RUBRIC>

Provide your evaluation in a structured format that can be easily parsed into the required object structure.
`;
}

export function getEvaluateMethodologyFunctions(methodology?: {
  title?: string;
  description?: string;
  subData?: MethodologySubData;
}) {
  if (!methodology) {
    return [];
  }

  const rubrics = methodology?.subData?.rubrics;

  const hasRubrics = rubrics && rubrics.length > 0;

  const allRubrics = `Evaluate all the following criteria : ${methodology?.subData?.rubrics?.join(',')}.`;

  return [
    {
      name: 'evaluateConversationBasedOnMethodology',
      description: `Evaluate the sales conversation based on the given methodology and rubric. ${hasRubrics && allRubrics.length < 700 ? allRubrics : ''}`,
      parameters: {
        type: 'object',
        properties: {
          overallReason: {
            type: 'string',
            description: 'Reason for the overall score',
          },
          overallImprovements: {
            type: 'string',
            description: 'Describe how to improve the sales',
          },
          evaluations: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                criterion: {
                  type: 'string',
                  description: `The criterion being evaluated.`,
                  enum: hasRubrics && allRubrics.length < 700 ? rubrics : undefined,
                },
                rating: {
                  type: 'integer',
                  description: 'Rating for the criterion (1-5)',
                  minimum: 1,
                  maximum: 5,
                },
                reason: {
                  type: 'string',
                  description: 'Reason for the given rating',
                },
                improvements: {
                  type: 'string',
                  description: 'Describe how to improve the sales',
                },
              },
              required: ['criterion', 'rating', 'reason', 'improvements'],
            },
          },
        },
        required: ['overallReason', 'overallImprovements', 'evaluations'],
      },
    },
  ];
}
